<template>
  <div class="reply-box">
    <div class="header-box">
      <UserProfile :data="item.user.person"></UserProfile>
      <div class="info-profile ml-2">
        <div class="name-user">{{ item.user.name }}</div>
        <div class="time-comment">
          {{
            moment(item.created_at)
              .startOf("day")
              .fromNow()
          }}
        </div>
      </div>
      <div class="flex flex-grow justify-end" v-if="item.user_id == userId.id">
        <button class="delete ml-2 opacity-25 transition duration-300 hover:opacity-100"
        :class="{'opacity-50':this.GET_LOADDING}"
        @click.prevent.stop="deleteAnswers"
        :disabled="this.GET_LOADDING">
          <Delete 
            class="cursor-pointer"
            width="20px"
            height="20px"
          />
        </button>
      </div>
    </div>
    <div class="comment mt-3 pb-3">
      <span>{{ item.answers }} </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UserProfile from "../components/UserCommets.vue";
import Delete from "./icons/Delete.vue";
export default {
  components: {
    UserProfile,
    Delete,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters("questions", ["GET_LOADDING"]),
    userId() {
      return JSON.parse(localStorage.getItem("user"));
    },
  },
  methods:{
    
    deleteAnswers() {
      if(!this.GET_LOADDING){
        this.$store.dispatch("questions/delete_answer_course", {
          _answer_id: this.item.id,
        });
      }
    },
  }
};
</script>

<style scoped>
.reply-box {
  opacity: 1;
  padding: 17px 13px 13px 17px;
  height: auto;
  margin-top: 20px;
  border-bottom: 1px solid #cccccc;
}

.reply {
  font: normal normal normal 13px/15px Roboto;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  width: 92px;
  height: 25px;
  background: #c6c6c6 0% 0% no-repeat padding-box;
  border-radius: 13px;
  text-align: center;
  line-height: 2;
  cursor: pointer;
}

.profile-image {
  width: 36px;
  height: 35px;
  background: #ef8d6e;
  border-radius: 50%;
}

.name-user {
  font: normal normal bold 15px/18px Roboto;
  letter-spacing: 0px;
  color: #65676b;
  opacity: 1;
}

.time-comment {
  font: normal normal normal 13px/15px Roboto;
  letter-spacing: 0px;
  color: #65676b;
  opacity: 1;
}

.header-box {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.comment {
  text-align: left;
  font: normal normal normal 13px/15px Roboto;
  letter-spacing: 0px;
  color: #65676b;
}
</style>
